module.exports = __webpack_public_path__ + "img/woman.41f91b67.png";